import { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Select, SelectOption, SelectValue, Table, Tooltip } from 'tdesign-react';

import { NovaImage } from '@/components/Image';
import { isRelease, SEARCH_ID, SEARCH_RELEASE } from '@/const/search';
import { Operand, OperatorsType } from '@/interface/numberSysytem';
import { numberSysNumColumns } from '@/pages/numberSystem/setNumberTable/table/config';
import { useAppDispatch, useTypedSelector } from '@/store';
import { getStoryNumberListStore } from '@/store/modules/storyNumber';

import styles from './index.module.less';


const { Option } = Select;

// 卡片数据类型定义
export interface ItemCardData {
  id: string;
  op: OperatorsType;
  operand: Operand
}

interface IProps {
  disabled?: boolean;
  onChange: (val: SelectValue<SelectOption>) => void;
  value: string;
  showError?: boolean
}

const NumberSystemSelect: React.FC<IProps> = (props) => {
  const { disabled, onChange, value, showError } = props;
  const [searchParams] = useSearchParams();
  const storyId = searchParams.get(SEARCH_ID) || '';
  const release = isRelease(searchParams.get(SEARCH_RELEASE));
  const [showLoading, setShowLoading] = useState(false);

  const dispatch = useAppDispatch();

  const { loading, list = [] } = useTypedSelector(store => store.storyNumber);

  const onPopupVisibleChange = (visible: boolean) => {
    if (visible) {
      if (storyId) {
        setShowLoading(true);
        dispatch(getStoryNumberListStore({ storyId, page: 1, size: 999, release }));
      }
    } else {
      setShowLoading(false);
    }
  };

  const valueDisplay = useMemo(() => list?.find(item => item?.id === value), [value, list]);

  return (
    <div style={{ flex: 1, margin: '0 6px' }}>
      <Select
        value={value}
        loading={showLoading && loading}
        style={{ flex: 1 }}
        placeholder='请选择变量'
        disabled={disabled}
        filterable
        onChange={val => onChange(val)}
        onPopupVisibleChange={visible => onPopupVisibleChange(visible)}
        valueDisplay={() => {
          if (!valueDisplay?.id) return null;
          return (

            <div className={styles.item}>
              <div className={styles.avatar}><NovaImage src={valueDisplay?.avatar} /></div>
              <Tooltip
                content={
                  <div>
                    {valueDisplay?.combineName}
                  </div>
                }
                destroyOnClose
                showArrow
                theme="default"
              >
                <div className={styles.value}>
                  {valueDisplay?.combineName}
                </div>
              </Tooltip>

            </div>
          );
        }}
      >
        {list?.map((option, idx) => (
          <Option style={{ height: '40px' }} key={idx} value={option?.id} label={option?.combineName}>
            <div className={styles.item}>
              <div className={styles.avatar}><NovaImage src={option?.avatar} /></div>
              <div className={styles.label}>
                <Tooltip
                  content={
                    <div>
                      <Table
                        rowKey="id"
                        data={[option]}
                        columns={numberSysNumColumns}
                        bordered={true}
                        stripe={true}
                      />
                    </div>
                  }
                  destroyOnClose
                  showArrow
                  theme="default"
                  key={idx}
                >
                  <div>{option?.combineName}</div>
                </Tooltip>
              </div>
            </div>
          </Option>
        ))}
      </Select>
      {value === undefined && showError && !disabled ? <div className={styles.errorMsg}>请选择变量</div> : null}
    </div>
  );
};

export default NumberSystemSelect;
